var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBirdybackSinFuente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.4 601.8",
    style: {
      enableBackground: "new 0 0 728.4 601.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#09747A;}\n\t.st1{fill:#039F82;}\n\t.st2{fill:#9EC83D;}\n\t.st3{fill:#E7E248;}\n\t.st4{fill:#C6D12D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.8,126.6c96.3,0,174.3,78,174.3,174.3l0,0h125.7c0-165.7-134.3-300-300-300s-300,134.3-300,300h125.7 C252.5,204.6,330.6,126.6,426.8,126.6L426.8,126.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 418.4,
    cy: 242.8,
    r: 33.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.6,475.2c-96.3,0-174.3-78-174.3-174.3l0,0H1.6c0,0.2,0,0.4,0,0.5C27.2,346.3,127.6,498.9,301.6,475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.3,536c192.1,18.6,280.1-81.2,292.8-97.2c-30.5,23.6-67.9,36.4-106.5,36.4 c-174,23.7-274.4-128.8-300-173.7C1.7,392.9,43.6,479.3,115.3,536z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.6,600.9c6.4,0,12.7-0.2,19-0.6C423.3,541,448.5,427.2,454.5,384.4c-11.6,21.1-27.4,39.6-46.4,54.4 c-12.7,15.9-100.8,115.8-292.8,97.2C168.2,578.1,233.9,601,301.6,600.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516.6,510c54.6-55.9,85.1-131,85-209.1H475.9c0,5.7-0.3,11.2-0.9,16.8C489,348.8,516.8,421.9,516.6,510z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M516.6,510c0.2-88.2-27.6-161.2-41.6-192.4c-2.2,23.4-9.2,46.1-20.5,66.8c-6,42.7-31.2,156.6-133.9,215.8 C394.9,595.6,464.8,563.4,516.6,510z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBirdybackSinFuente);
export default __webpack_public_path__ + "static/media/logo-birdyback-sin-fuente.56e8aec6e2d352e29a66b0d6b722975b.svg";
export { ForwardRef as ReactComponent };